import React from 'react';
import { Box, Heading, Text, Button, VStack } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface NotFoundProps {
  /** When true, page is rendered inside DashboardLayout. */
  inDashboard?: boolean;
}

const NotFound: React.FC<NotFoundProps> = ({ inDashboard }) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const isLoggedIn = !!user;
  const showDashboardChrome = inDashboard ?? isLoggedIn;

  const homePath = isLoggedIn ? '/dashboard/overview' : '/';
  const homeLabel = isLoggedIn ? 'Back to dashboard' : 'Go to home';

  return (
    <Box
      textAlign="center"
      py={showDashboardChrome ? { base: 12, md: 16 } : 10}
      px={6}
      minH={showDashboardChrome ? undefined : '100vh'}
      display={showDashboardChrome ? 'block' : 'flex'}
      alignItems={showDashboardChrome ? undefined : 'center'}
      justifyContent={showDashboardChrome ? undefined : 'center'}
    >
      <VStack spacing={4} maxW="md" mx="auto">
        <Heading
          display="inline-block"
          as="h2"
          size="2xl"
          bgGradient="linear(to-r, teal.400, teal.600)"
          backgroundClip="text"
        >
          404
        </Heading>
        <Text fontSize="lg" fontWeight="medium">
          Page not found
        </Text>
        <Text color="gray.500">
          The page you&apos;re looking for does not exist or may have been moved.
        </Text>
        <Button colorScheme="teal" onClick={() => navigate(homePath)}>
          {homeLabel}
        </Button>
      </VStack>
    </Box>
  );
};

export default NotFound;
